import Fee from "@/model/Fee/Fee"
import ApplicationFee from "@/model/Fee/ApplicationFee"
import FeeContent from "@/model/Content/FeeContent";
import feeIdToContent from "@/config/feeIdToContent"

import { FeeQuote } from "@requests"


export interface IFeeFactory { }

class FeeFactory implements IFeeFactory {

    public static createFee(obj: FeeQuote): Fee {
        let fee: Fee;
        let feeName = window.content['summary_fee'];

        // Iterate over feeTypeMap to match obj.reference with the appropriate key (array of IDs)
        for (const [ids, contentKey] of feeIdToContent.entries()) {
            if (ids.has(obj.reference)) {
                const nameToUse: string | undefined = window.content[contentKey]
                if (nameToUse) feeName = window.content[contentKey];
                break;
            }
        }

        // Determine the type of Fee to create based on whether feeName was found
        if (feeName) {
            fee = new ApplicationFee(obj.reference, obj.value);
        } else {
            fee = new Fee(obj.reference, obj.value);
        }

        const feeContent = new FeeContent(feeName);
        fee.setContent(feeContent);

        return fee;
    }
}

export default FeeFactory